import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'

export default function () {
  return {
    accesses: [],
    pagination: new Pagination(),
    formatDate,
    totals: {
      teacher: 0,
      student: 0,
    },
  }
}
